import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { OrderType } from "@gql/offer";
import { LimitOrdersTrackingFacade } from "@modules/limit-orders/services/orders-rudderstack.facade";
import { OrderFlow } from "@modules/limit-orders/interfaces/limit-order-rudderstack.model";
import { OpenDetailsModel } from "@modules/limit-orders/ui/order-adp-widget/order-adp-widget.component";
import { OrdersFollowingWidgetFacade } from "@modules/limit-orders/services/orders-widgets-following.facade";
import { SELL_ORDERS_PILL_VALUE } from "@helpers/const/following-options";
import { IWidgetAdpOrder } from "@modules/limit-orders/interfaces/limit-orders-widget-adp.model";
import {
	CombinedFollowingWidgetOrderData,
	IFollowingCountData
} from "@modules/limit-orders/interfaces/limit-order-following.model";

@Component({
	selector: "limit-orders-widget-ui",
	templateUrl: "./limit-orders-widget.component.html",
	styleUrls: ["./limit-orders-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LimitOrdersWidgetComponent implements OnInit {
	private readonly limitOrdersTrackingFacade = inject(LimitOrdersTrackingFacade);
	private readonly followingWidgetFacade = inject(OrdersFollowingWidgetFacade);

	@Input({ required: true }) public vm: CombinedFollowingWidgetOrderData<IWidgetAdpOrder[]>;
	@Input({ required: true }) counts: IFollowingCountData;
	@Input({ required: true }) selectedPill: string;

	isNewSellVisible = false;
	showCheckOrders = false;

	@Output() public onRefetchOrders = new EventEmitter<void>();
	@Output() public onGoToLimitOrders = new EventEmitter<void>();

	ngOnInit(): void {
		//check if there are any orders to show the check orders button
		if (this.counts) {
			const { buyOrders, sellOrders, executedOrders, cancelledOrders } = this.counts;
			this.showCheckOrders = buyOrders > 0 || sellOrders > 0 || executedOrders > 0 || cancelledOrders > 0;
		}

		if (this.selectedPill) {
			this.isNewSellVisible =
				this.selectedPill === SELL_ORDERS_PILL_VALUE && this.followingWidgetFacade.hasSellBalance();
		}
	}

	public onRefetchLimitOrders(): void {
		this.onRefetchOrders.emit();
	}

	public goToLimitOrders(): void {
		this.onGoToLimitOrders.emit();
	}

	public openDetails(event: OpenDetailsModel): void {
		const { orderId, orderType } = event;
		this.followingWidgetFacade.goToOrderDetail(orderId, orderType);
	}

	public createOrder(orderType?: OrderType): void {
		this.limitOrdersTrackingFacade.updateFlow(OrderFlow.HomeEmptyOrders);
		if (orderType) {
			this.followingWidgetFacade.openAssetSelection(orderType);
			return;
		}
		this.limitOrdersTrackingFacade.updateFlow(OrderFlow.HomeGrouped);
		this.followingWidgetFacade.openGenericOrderFlow();
	}
}
